import { getAccountAge } from "@/utils/getAccountAge";
import { CurrentLevelInfo } from "../community/CurrentLevelInfo";
import CustomAvatar from "../community/CustomAvatar";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { Button } from "./button";
import { MixpanelActions } from "@/integrations/mixpanel/mixpanel";

function ProfilePopup({ authorData, authorId }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  if (!authorData || !authorId) return null;
  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
      className="absolute z-50 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-lg rounded-xl p-4 cursor-default"
    >
      <div className="flex gap-4 mb-2">
        <div>
          <CustomAvatar userData={authorData} size="xxl" />
        </div>
        <div>
          <h3 className="text-2xl whitespace-nowrap">
            {authorData.username}
          </h3>
          <p className="whitespace-nowrap">
            {t("community.profileComponent.joined", {
              days: getAccountAge(authorData?.created_at),
            })}
          </p>
          <CurrentLevelInfo score={authorData?.user_rating?.score} />
        </div>
      </div>

      <Button
        variant="default"
        size="full"
        onClick={() => {
          MixpanelActions.clickUserProfile();
          navigate(`/user/${authorId}`);
        }}
      >
        Profile
      </Button>
    </div>
  );
}

export default ProfilePopup;
